module.exports = __webpack_public_path__ + "static/media/logo103.a1a30997.png";